import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../fonts/nimbus-sans-l-regular-webfont.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/nimbus-sans-l-bold-webfont.woff2\",\"weight\":\"700\",\"style\":\"normal\"}],\"variable\":\"--font-nimbus\"}],\"variableName\":\"nimbusSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/analytics/google-ads-route.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/cookies/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/components/google-merchant-widget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/register-promo/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
